import { useCallback } from "react";

import { useFocusEffect } from "@/crossPlatform/expo-router";
import { useAnalytics } from "@/services/Analytics";
import type { MixpanelProps } from "@/services/Analytics";

interface UseScreenViewAnalytics {
  properties?: MixpanelProps;
  screenName: string;
}

const useScreenViewAnalytics = ({
  properties,
  screenName,
}: UseScreenViewAnalytics) => {
  const { trackPageView } = useAnalytics();
  useFocusEffect(
    // Per expo-router docs:
    // Callback should be wrapped in `React.useCallback` to avoid running the effect too often.
    useCallback(() => {
      trackPageView(screenName, properties);
    }, [properties, screenName, trackPageView]),
  );
};

export default useScreenViewAnalytics;
